export default ({ description = 'rails' } = {}) => {
  const eventbus = document.createComment(description)
  document.appendChild(eventbus)

  return {
    on: (type, listener) => {
      eventbus.addEventListener(type, listener)
    },
    once: (type, listener) => {
      eventbus.addEventListener(type, listener, { once: true })
    },
    off: (type, listener) => {
      eventbus.removeEventListener(type, listener)
    },
    emit: (type, detail) => eventbus.dispatchEvent(new CustomEvent(type, { detail })),
  }
}
